import { useContext } from "react";
import { globalContext } from "../../global/Store";
import config from "../../config/Config.json";
import { GetMockCaseNoteList } from "../../mock/case-note/CaseNoteList";
import { GetMockCaseNoteRead } from "../../mock/case-note/CaseNoteRead";

export const useCaseNoteDataRepo = () => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);

  const GetCaseNoteList = (id: number, incDeleted: boolean) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockCaseNoteList());
      } else {
        globalFunctions
          .CallPortalApi("CaseNote/List", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
              IncludeDeleted: incDeleted,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const GetCaseNote = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockCaseNoteRead());
      } else {
        globalFunctions
          .CallPortalApi("CaseNote/Read", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  return { GetCaseNote, GetCaseNoteList };
};
